module.exports = __webpack_public_path__ + "static/manage-70b4c4ef58704d1b62cdba8a892b1205.jpg";